import { useEffect, useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { ARROW_DIRECTION_ICON } from './constants'
import { CarouselNewArrow } from '../carousel-new-arrow'
import './style.scss'

export function CarouselNew({
  align = 'center',
  children,
  loop = false,
  variableWidth = false,
  gap = '10px',
  slidesToScroll = '1',
  itemsPerView = 0,
  customArrowComponent = null,
  withDots = false,
  dragFree = false,
  containScroll = true,
  breakpoints = {},
  autoPlaySpeed = 0,
}) {
  const [ref, api] = useEmblaCarousel({
    align,
    loop,
    slidesToScroll,
    container: 'carousel-slides-container',
    dragFree,
    containScroll,
    breakpoints,
  })
  const [canScrollPrev, setCanScrollPrev] = useState(false)
  const [canScrollNext, setCanScrollNext] = useState(false)

  useEffect(() => {
    function initArrows() {
      if (!api) return

      resolveButtonState()
      api.on('reInit', resolveButtonState)
      api.on('select', resolveButtonState)
    }

    initArrows()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api])

  useEffect(() => {
    const interval =
      autoPlaySpeed &&
      setInterval(() => {
        if (api) api.scrollNext()
      }, autoPlaySpeed)

    return () => clearInterval(interval)
  }, [api, autoPlaySpeed])

  function handlePrev() {
    if (!api) return
    api.scrollPrev()
    resolveButtonState()
  }

  function handleNext() {
    if (!api) return
    api.scrollNext()
    resolveButtonState()
  }

  function resolveButtonState() {
    if (!api) return

    setCanScrollPrev(api.canScrollPrev())
    setCanScrollNext(api.canScrollNext())
  }

  function getArrowComponent() {
    if (withDots) return null
    if (!canScrollPrev && !canScrollNext) return null
    return customArrowComponent || CarouselNewArrow
  }

  function renderPrevArrow() {
    const Arrow = getArrowComponent()
    if (!Arrow) return null

    return <Arrow icon={ARROW_DIRECTION_ICON.PREV} onClick={handlePrev} disabled={!canScrollPrev} />
  }

  function renderNextArrow() {
    const Arrow = getArrowComponent()
    if (!Arrow) return null

    return (
      <Arrow
        icon={ARROW_DIRECTION_ICON.NEXT}
        onClick={handleNext}
        disabled={!canScrollNext}
        isNext
      />
    )
  }

  function renderSlides() {
    const variableWidthClass = variableWidth ? 'variable-width' : ''
    const itemsPerViewClass = itemsPerView ? `items-per-view-${itemsPerView}` : ''
    return (
      <div
        className={`carousel-slides-container ${variableWidthClass} ${itemsPerViewClass}`}
        style={{ gap }}
      >
        {children}
      </div>
    )
  }

  return (
    <div className='carousel-new-container'>
      {renderPrevArrow()}
      <div className='carousel-viewport' ref={ref}>
        {renderSlides()}
      </div>
      {renderNextArrow()}
    </div>
  )
}
